import React from "react";
import useCurrencyName from "../../hooks/useCurrencyName";
import { getCurrencyLabel } from "../../store/utils";
import { formatNumberByInstrument } from "../../utils/format-number";

const VictorShowMultipleItems = ({historicalShareList = [], }) => {
  const getCurrencyNameByCode = useCurrencyName()
  return (
    <div className="history-multiple-items">
      {historicalShareList
        .map((item, i) => (
          <div className="history-multiple-items__item" key={i} tabIndex={0} role="article">
            <div className="history-multiple-items__item--top">
              <span className="market-name">{item.ticker}</span> {item.marketAbbreviation ? <span className="market-code">({item.marketAbbreviation})</span> : null}
            </div>
            <div className="history-multiple-items__item--middle" role="note" aria-label={item.close + ' ' + getCurrencyNameByCode(item.currency)}>{formatNumberByInstrument(item.close, item.instrumentId)} ({getCurrencyLabel(item.currency)})</div>
            <div className="history-multiple-items__item--bottom">({item.marketName})</div>
          </div>
        ))}
    </div>
  );
};

export default VictorShowMultipleItems;
